/*
 * @Author: gujianghua
 * @Date:   2018-07-12 12:47:38
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2020-08-11 10:34:42
 */
import { service,BASE_API } from '@/utils/request'

const v2 = BASE_API

/**
 * [getSelect 获取职称，科室，审核方式，注册来源等信息集合]
 * @return {[obj]}
 */
/*export function getSelect() {
  return service({
    url: '/cloud/uac/doctorManager/getSelect',
    method: 'get',
  })
}*/
// 提交认证
export function assistAuth(data) {
  return service({
    url: '/cloud/uac/auth/optimize/assistAuth',
    method: 'post',
    data
  })
}

//模糊搜索医院
export function searchHospital(params) {
  return service({
    url: '/cloud/uac/hospital/hospitalList/search',
    method: 'get',
    params: params
  })
}

//新增未审核医生
export function addDoctorNoAuth(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/doctor/addDoctorNoAuth',
    method: 'post',
    params: params,
    data: data
  })
}
//新增普通认证医生
export function addDoctorAuth(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/doctor/addDoctorAuth',
    method: 'post',
    params: params,
    data: data
  })
}
//新增权威认证医生
export function addDoctorAuthCert(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/doctor/addDoctorAuthCert',
    method: 'post',
    params: params,
    data: data
  })
}

//获取医生信息
export function getDocInfo(path, param) {
  return service({
    url: '/cloud/uac/doctorManager/getDoctorInfo' + path,
    method: 'get',
    param
  })
}
//编辑医生信息
export function updateDoctorInfo(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/doctor/updateSubmit',
    method: 'post',
    params: params,
    data: data
  })
}


// 用户解绑微信
export function unbindWechat(params) {
  return service({
      url: '/cloud/uac/doctorManager/unbindWechat',
      method: 'post',
      params
    })
}
  // 获取机构
export function getOrg(params) {
  return service({
    url: '/cloud/uac/doctorManager/getOrg/' + params,
    method: 'get'
  })
}

  // 添加机构
export function addOrg(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/addOrg',
    method: 'post',
    params: params,
    data: data
  })
}
  // 修改机构
export function updateOrg(params, data) {
  return service({
    url: '/cloud/uac/doctorManager/updateOrg',
    method: 'post',
    params: params,
    data: data
  })
}
export default {
  /**
   * [disableDoc 禁用医生]
   * @param  {[obj]} data [登录用户信息，医生id]
   * @return {[obj]}
   */
  disableDoc: function disableDoc(data) {
    return service({
      url: '/cloud/uac/doctorManager/doctor/disable',
      method: 'post',
      data: data
    })
  },

  /**
   * [getDocList 医生列表]
   * @param  {[obj]} params [分页参数]
   * @param  {[obj]} data   [筛选条件]
   * @return {[obj]}
   */
  getDocList: function getDocList(params, data) {
    return service({
      url: '/cloud/uac/doctorManager/getDoctorPage',
      method: 'post',
      params: params,
      data: data
    })
  },


  /**
   * [exportDoc 导出医生]
   * @param  {[obj]} params [筛选条件]
   * @return {[obj]}
   */
  exportDoc: function exportDoc(params) {
    // let url = v2 + '/cloud/uac/doctorManager/getDoctorExcel?' +
    //   searchParamsFormatter(params)
    // window.location.href = url
    return service({
			url: '/cloud/uac/doctorManager/getDoctorExcel',
			method: 'get',
			params,
			responseType: 'blob'
		})
  },

  /**
   * [resetPwd 重置密码]
   * @param  {[object]} data [用户id]
   * @return {[obj]}
   */
  resetPwd: function resetPwd(data) {
    return service({
      url: '/cloud/uac/doctorManager/doctor/resetPwd/' + data.id,
      method: 'post'
    })
  },

  /**
   * [deleteDoc 删除医生]
   * @param  {[obj]} data [登录者id,name,医生id]
   * @return {[obj]}
   */
  deleteDoc: function deleteDoc(data) {
    return service({
      url: '/cloud/uac/doctorManager/doctor/delete',
      method: 'post',
      data: data
    })
  },

  /**
   * [updatePhone 修改用户手机号]
   * @param  {[string]} path   [id]
   * @param  {[obj]} params [手机号]
   * @return
   */
  updatePhone: function updatePhone(path, params) {
    return service({
      url: '/cloud/uac/doctorManager/doctor/updatePhone/' + path,
      method: 'post',
      params: params
    })
  },
  /**
   * [getIntegralLogList 筛选条件]
   * @param  {[obj]} params [筛选条件]
   * @return {[obj]}
   */
  getIntegralLogList(params) {
    return service({
      url: '/cloud/mission/v1/integration/admin/getIntegralLogPage',
      method: 'get',
      params: params
    })
  },
  /**
   * [getChannelList 获取渠道]
   * @param  {[obj]} params [type:1 钱包，2 积分（学习币）]
   * @return {[obj]}
   */
  getChannelList(params) {
    return service({
      url: '/cloud/uac/wallet/listGroup',
      method: 'get',
      params: params
    })
  },

  /**
   * [getIntegralLogTotal 学习币汇总]
   * @param  {[obj]} params [同学习币列表]
   * @return {[obj]}
   */
  getIntegralLogTotal(params) {
    return service({
      url: '/cloud/mission/v1/integration/admin/getIntegralLogStat',
      method: 'get',
      params: params
    })
  },
  /**
   * [getWalletList 获取钱包列表]
   * @param  {[obj]} params [获取钱包列表]
   * @return {[obj]}
   */
  getWalletList(params) {
    return service({
      url: '/cloud/uac/wallet/listLogs',
      method: 'get',
      params: params
    })
  },

  /**
   * [editWallet 操作钱包]
   * @param  {[obj]} params [医生id,渠道，金额，备注]
   * @return {[obj]}
   */
  editWallet(params) {
    return service({
      url: '/cloud/uac/wallet/operate',
      method: 'get',
      params: params
    })
  },
  /**
   * [editintegral 操作学习币]
   * @param  {[obj]} params [医生id,渠道，金额，备注]
   * @return {[obj]}
   */
  editintegral(params) {
    return service({
      url: '/cloud/uac/integral/operate',
      method: 'get',
      params: params
    })
  },
  /**
   * [loginToYouzan 登录到有赞]
   * @param  {[obj]}
   * @return {[obj]}
   */
  loginToYouzan(data) {
    return service({
      url: '/cloud/uac/v1/youzan/login',
      method: 'POST',
      data: data
    })
  },
  youzanCouponList() {
    return service({
      url: '/cloud/uac/v1/youzan/card/getYouzanCoupon',
      method: 'get'
    })
  },
  /**
   * [giveDoctor 发放给医生]
   * @param  {[obj]} params []
   * @return {[obj]}
   */
  giveDoctor(data) {
    return service({
      url: '/cloud/uac/v1/youzan/card/takeYouzanCoupon',
      method: 'post',
      data: data
    })
  },
  /**
   * [sendMsg 群发短信]
   * @param  {[obj]} params [同列表筛选条件]
   * @return {[obj]}
   */
  sendMsg(params,data) {
    return service({
      url: '/cloud/uac/doctorManager/sendSmsBatch',
      method: 'post',
      data: data,
      params: params
    })
  },

  /**
  * [sendMsg 单发短信]
  * @param  {[obj]} params [id,content]
  * @return {[obj]}
  */
  sendMsgOne(params) {
    return service({
      url: '/cloud/uac/doctorManager/sendSmsSingle',
      method: 'post',
      params: params
    })
  },

  getAllVipCard() {
    return service({
      url: '/cloud/uac/vipCard/allCard',
      method: 'get'
    })
  },

  getDocListTotal(data) {
    return service({
      url: '/cloud/uac/doctorManager/getDoctorPageExtraInfo',
      method: 'post',
      data: data
    })
  },
  editDocInfo: (data) => {
    return service({
        url: '/cloud/uac/doctorManager/update',
        method: 'post',
        data: data
      })
  },
  // 开通vip
  openVIP: (data) => {
    return service({
        url: '/cloud/uac/doctor/vip/openVIPWithDaysV3',
        method: 'post',
        data
      })
  },
  // 清空历史设备
  clearHistoryDevice: (params) => {
    return service({
        url: '/cloud/uac/vip/student/card/cleanAllDevice',
        method: 'post',
        params
      })
  },
  // 批量开通VIP
  excelOpenVip: v2 + '/cloud/uac/doctor/vip/importOpenVipV3',
  // 批量新增医生
  excelUpload: v2 + '/cloud/uac/doctorManager/importDoctorExcel',
  // 下载模板
  down: 'https://file.ibabygroup.cn/addDoctors1.xls',

  // 用户绑定设备列表
  getDeviceList: (params) => {
    return service({
        url: '/cloud/uac/api/userLogin/devices',
        method: 'get',
        params
      })
  },
  // 用户绑定设备列表
  unbindDevice: (params) => {
    return service({
        url: '/cloud/uac/admin/userLogin/unbindDevice',
        method: 'post',
        params
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/userManage/docList.js